import React from 'react';
import CopyButton from '../utils/CopyButton';
import fromReactElementToCopyable from '../utils/fromReactElementToCopyable';

const DefaultTypeInteger = props => {
  const {
    data,
    schema,
    path = [],
    enableCopyField,
    customCopyFieldComponent,
  } = props;

  const copyableText = fromReactElementToCopyable(data);

  return (
    <div className={`default-type-integer depth-${path.length}`}>
      <strong className="default-type-integer-title">{schema.title}</strong>{' '}
      <span className="default-type-integer-value">{data}</span>
      {enableCopyField && (
        <CopyButton
          text={copyableText}
          customButton={customCopyFieldComponent}
        />
      )}
    </div>
  );
};

export default DefaultTypeInteger;
